import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/VideosTable.vue"),
          meta: { title: "Список видео", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "create/:museumId",
          component: () => import("@/views/forms/VideosForm.vue"),
          meta: { title: "Создать видео", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/VideosForm.vue"),
          meta: { title: "Редактировать видео", activeMenuParent: true },
          hidden: true,
        },
      ],
    },
  ];
};
